import React from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function AdminShell({ children, title, actions }) {
  const { user, logout } = useAuth();
  const menu = [
    ["/admin", "Pagina"],
    ["/admin/inductees", "Inductees"],
    ["/admin/bestuursleden", "Bestuur"],
    ["/admin/partners", "Partners"],
    ["/admin/galerij", "Fotogalerie"],
    ["/admin/media", "Media"],
    ["/admin/videos", "Video's"],
    ["/admin/publicaties", "Publicaties"],
    ["/admin/inschrijvingen", "Inschrijvingen"],
    ["/admin/beheerders", "Beheerders"],
  ];
  return (
    <div style={{ minHeight: "100vh", background: "var(--ink)", color: "var(--cream)" }}>
      <header style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 24, flexWrap: "wrap", padding: "22px clamp(20px, 4vw, 48px)",
        borderBottom: "1px solid var(--line)",
      }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: 18, flexWrap: "wrap" }}>
          <span style={{
            fontFamily: "var(--serif)", fontSize: 14, letterSpacing: "0.28em",
            textTransform: "uppercase",
          }}>SWOF</span>
          <nav style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {menu.map(([pad, label]) => (
              <Link key={pad} to={pad} data-testid={`admin-nav-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
                style={{
                  fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: window.location.pathname === pad ? "var(--gold)" : "rgba(243,234,215,0.6)",
                }}>{label}</Link>
            ))}
          </nav>
          {!menu.some(([, label]) => label === title) && (
            <span style={{
              fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.22em",
              textTransform: "uppercase", color: "var(--gold)",
            }}>{title}</span>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
          {actions}
          <span style={{ fontFamily: "var(--sans)", fontSize: 12, opacity: 0.6 }}>{user?.email}</span>
          <button onClick={logout} data-testid="admin-logout" style={{
            fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em",
            textTransform: "uppercase", color: "var(--gold)",
            border: "1px solid rgba(201,169,97,0.4)", padding: "10px 16px", background: "transparent",
          }}>Uitloggen</button>
        </div>
      </header>
      <main style={{ padding: "clamp(24px, 4vw, 56px)", maxWidth: 1180, margin: "0 auto" }}>
        {children}
      </main>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div style={{ minHeight: "100vh", background: "var(--ink)" }} data-testid="auth-checking" />;
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
